import React from 'react';

import Layout from '../../components/Layout';
import girlsImg from './images/confirmation-image.jpg';
import './styles.scss';

const UpgradeThanks = () => (
  <Layout>
    <section className="upgrade-thanks">
      <h2 className="mobile">
        Success!
        <br />
        You’re Now an Annual Member!
      </h2>
      <div className="upgrade-thanks__image">
        <img src={girlsImg} alt="thanks" />
      </div>
      <div className="upgrade-thanks__text">
        <h2 className="desktop">Success! You’re Now an Annual Member!</h2>
        <p>
          Thank you for upgrading. You’ll receive an email confirming your Annual subscription.
          You’re all set to receive a year’s worth of FabFitFun boxes, in addition to any
          previously purchased seasonal boxes.
        </p>
        <p>
          You’ll receive notifications via email when Annual personalization options are available.
        </p>
        <a className="upgrade-thanks__link fff-btn-primary desktop" href="/">GO TO DASHBOARD</a>
      </div>
    </section>
  </Layout>
);

export default UpgradeThanks;
